import { convertFromRaw, EditorState, DraftInlineStyle, ContentState } from 'draft-js'
import { stateToHTML, Options } from 'draft-js-export-html'
import { normalizeToHex } from '@systemeio/util'

export const getCurrentContentFromRawContent = (rawContent: string) =>
  EditorState.createWithContent(convertFromRaw(JSON.parse(rawContent))).getCurrentContent()

export const getHtmlFromContentState = (
  contentState: ContentState,
  linkColor?: string,
  options?: Options,
) =>
  stateToHTML(contentState, {
    defaultBlockTag: 'div',
    entityStyleFn: entity => {
      const entityType = entity.getType().toLowerCase()
      if (entityType === 'link') {
        const { action, url, ...restData } = entity.getData()
        return {
          element: 'a',
          attributes: {
            ...restData,
            href: url,
          },
          style: linkColor ? { color: normalizeToHex(linkColor) } : {},
        }
      }

      return
    },
    // @ts-expect-error - idk will be removed after tip-tap update
    inlineStyleFn: (styles: DraftInlineStyle) => {
      const color = styles
        .filter(style => (style ? new RegExp('^rgba?').test(style) : false))
        .first()

      const fontSizeKey = styles
        .filter(style => (style ? style.startsWith('FONT_SIZE_') : false))
        .first()

      if (!color && !fontSizeKey) {
        return
      }

      return {
        element: 'span',
        style: {
          ...(color ? { color: normalizeToHex(color) } : {}),
          ...(fontSizeKey ? { fontSize: Number(fontSizeKey.split('_')[2]) } : {}),
        },
      }
    },
    ...options,
  })
